import { makeFinalRequest, makeGetRequest, makePutRequest } from '../general/general-service';
import { serviceConfigs } from '../general/configs';

export const getTagMorePages = (tagId, type, page = 1) => {
	const finalRequestUrl = makeFinalRequest(`tags/${tagId}/${type ? type : 'page'}`,
		type ? { page: page } : {});
	return makeGetRequest(finalRequestUrl);
};
export const getCategoryPages = (catId, type, page = 0,  size= 200) => {
	const finalRequestUrl = makeFinalRequest(`${type ? type : 'page'}/category/${catId}`,
		{
			page: page,
			size: size,
		}, 2);
	return makeGetRequest(finalRequestUrl);
};
export const getGenrePages = (catId, type, page = 0,  size= 200) => {
	const finalRequestUrl = makeFinalRequest(`${type ? type : 'page'}/genre/${catId}`,
		{
			page: page,
			size: size,
		}, 2);
	return makeGetRequest(finalRequestUrl);
};

export const rateAProgram = (programId, rateNumber = 0) => {
	const finalRequestUrl = makeFinalRequest(`interaction/rate/${programId}?rate=${rateNumber}`);
	return makePutRequest(finalRequestUrl);
};

export const getWithTagMorePages = (tagId, type, page = 1) => {
	const finalRequestUrl = makeFinalRequest(`tags/with-tag/${tagId}/${type ? type : 'page'}`,
		type ? { page: page } : {});
	return makeGetRequest(finalRequestUrl);
};

export const getProgramMorePages = (programType, programId, page = 1, option) => {
	const finalRequestUrl = makeFinalRequest(`tags/${programId}/${programType}`, {
		page: page
	});
	return makeGetRequest(finalRequestUrl);
};
